import React from "react";
import { faker } from "@faker-js/faker";



import {
  Table,  TableBody, TableCell, TableContainer, TableHead, TableRow , Paper, Avatar, Typography
} from '@mui/material';





let dataTable = [], Statuss = ['Active', 'Pending', 'Blocked']

for (let i = 0; i < 20; i++) {
  dataTable[i] = {
    // Name : faker.name.middleName()  ,
    Name: faker.name.firstName(),
    email: faker.internet.email(),
    phone: faker.phone.number(),
    amount: faker.finance.amount(),
    status: Statuss[Math.floor(Math.random() * Statuss.length)  ]
  }
}
const MyTable = () => {
 
  return (
   <>
   <div style={{height:"300px"}}>
    <React.Fragment>
      <TableContainer component={Paper} style={{  borderRadius:0, border: "2px solid black", margin: "0 auto " ,height:"300px"}}  >
        <Table sx={{ minWidth: 400 }} aria-label="simple table"  >
          <TableHead>
            <TableRow style={{ backgroundImage: "linear-gradient(270deg,rgba(5,50,100,10),#00d4ff)" }}>
              <TableCell style={{ color: "white" ,fontSize: 16 }}>Name</TableCell>
              <TableCell style={{ color: "white", fontSize: 16  }}>Amount</TableCell>
              <TableCell style={{ color: "white", fontSize: 16  }}>Email</TableCell>
              <TableCell style={{ color: "white", fontSize: 16  }} >Phone</TableCell>
              <TableCell style={{ color: "white", fontSize: 16  }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody style={ {backgroundImage: "linear-gradient(270deg ,#00d4ff,rgba(5,50,100,10))"}}>
            {dataTable.map((row) => (
              <TableRow
                key={row.name}
                sx={{'&:last-child td, &:last-child th': {border: 0}}}
              
              >

                <TableCell className="" style={{color:"white"}}> <Avatar style={{  backgroundColor: "black", textAlign:"center" ,padding:"3" }} />{row.Name}</TableCell>
                <TableCell >
                  <Typography color="white"  style={{  fontWeight: "bolder" }}   >
                    ${row.amount}
                  </Typography>

                </TableCell>
                <TableCell >
                  <Typography color="white"  >
                    {row.email}
                  </Typography>
                </TableCell>
                <TableCell >
                  <Typography color="white"  >
                    {row.phone}
                  </Typography>

                </TableCell>
                <TableCell className="text-center text-white">
                  <Typography className="tableStatus" style={{backgroundColor: row.status === "Active" ? "rgba(5,50,100,10)" : row.status=== "Pending" ? "rgba(5,50,100,10)":  "rgba(5,50,100,10)"  }}  >
                    {row.status}                   
                
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

    </React.Fragment>
    </div>
    </>
  );
}

export default MyTable;